goog.provide("shadow.js.shim.module$src$svg$controls$view_list_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$view_list_svg");
shadow.js.shim.module$src$svg$controls$view_list_svg = shadow.js.nativeProvides["src/svg/controls/view-list.svg"] = shadow$bridge("src/svg/controls/view-list.svg");
module$shadow_js_shim_module$src$svg$controls$view_list_svg.default = shadow.js.shim.module$src$svg$controls$view_list_svg;
